<script setup lang="ts">
    import { AgentChannel, AgentType } from 'models'
    import { computed } from 'vue'
    import PkFieldset from '../PkFieldset.vue'

    const props = defineProps<{
        type?: AgentType | string
    }>()

    const channels = defineModel<AgentChannel[]>({
        default: () => Object.values(AgentChannel),
    })

    const isChatAgent = computed(() => props.type === AgentType.Chat)

    function isEnabled(channel: AgentChannel): boolean {
        return channels.value.includes(channel)
    }

    function toggle(channel: AgentChannel, enabled: boolean): void {
        if (enabled) {
            channels.value = [...channels.value, channel]
        } else {
            channels.value = channels.value.filter((c) => c !== channel)
        }
    }
</script>

<template>
    <PkFieldset :legend="$t('label.channels')">
        <VvCheckbox
            :model-value="isEnabled(AgentChannel.Frontoffice)"
            name="channel.frontoffice"
            :value="true"
            :unchecked-value="false"
            switch
            class="flex-nowrap"
            @update:model-value="
                (val: boolean) => toggle(AgentChannel.Frontoffice, val)
            ">
            <div class="flex flex-col ml-12 gap-2">
                <strong class="font-semibold">
                    {{ $t('agent.channel.frontoffice') }}
                </strong>
                <small class="text-12 text-word-3">
                    {{ $t('hint.channel.frontoffice') }}
                </small>
            </div>
        </VvCheckbox>
        <VvCheckbox
            v-if="isChatAgent"
            :model-value="isEnabled(AgentChannel.App)"
            name="channel.app"
            :value="true"
            :unchecked-value="false"
            switch
            class="flex-nowrap"
            @update:model-value="
                (val: boolean) => toggle(AgentChannel.App, val)
            ">
            <div class="flex flex-col ml-12 gap-2">
                <strong class="font-semibold">
                    {{ $t('agent.channel.app') }}
                </strong>
                <small class="text-12 text-word-3">
                    {{ $t('hint.channel.app') }}
                </small>
            </div>
        </VvCheckbox>
        <VvCheckbox
            v-if="isChatAgent"
            :model-value="isEnabled(AgentChannel.Widget)"
            name="channel.widget"
            :value="true"
            :unchecked-value="false"
            switch
            class="flex-nowrap mb-0"
            @update:model-value="
                (val: boolean) => toggle(AgentChannel.Widget, val)
            ">
            <div class="flex flex-col ml-12 gap-2">
                <strong class="font-semibold">
                    {{ $t('agent.channel.widget') }}
                </strong>
                <small class="text-12 text-word-3">
                    {{ $t('hint.channel.widget') }}
                </small>
            </div>
        </VvCheckbox>
    </PkFieldset>
</template>
